import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../../config";
import { purewebContext } from "../../../../context/PurewebContext";

const Upload3DContainer = ({ sendMessage }) => {
  const { setUpload3DContainerVisible } = useContext(purewebContext);
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (errorMessage) {
      const t = setTimeout(() => setErrorMessage(""), 5000);
      return () => clearTimeout(t);
    }
  }, [errorMessage]);

  const clearAll = () => {
    setUpload3DContainerVisible(false);
    setFile(null);
    setUploading(false);
    setErrorMessage("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 80 * 1024 * 1024) {
      return setErrorMessage("File size must be less than 80MB");
    }

    setFile(file);
    setUploading(true);
    setErrorMessage("");

    const formData = new FormData();
    formData.append("3dFile", file);

    try {
      const userEmail = localStorage.getItem("userEmail");
      const response = await axios.post(
        `${API_BASE_URL}/upload3d/${userEmail}`,
        formData
      );
      console.log("3D File uploaded successfully:", response.data);
      sendMessage(`3dmodel:uploaded,${JSON.stringify(response.data)}`);
      if (fileInputRef.current) fileInputRef.current.value = "";
      clearAll();
    } catch (e) {
      console.log(e);
      setErrorMessage(e?.response?.data?.error?.message || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="file-upload-overlay">
      <div className="file-upload-modal">
        <h2 className="file-upload-title">Add Custom Object</h2>
        <p className="file-upload-description">
          To add your custom object, please upload a 3D model file in .fbx format.
        </p>
        <input
          ref={fileInputRef}
          className="file-upload-input"
          type="file"
          onChange={handleFileChange}
          accept=".fbx, .FBX"
          style={{ display: "none" }}
        />
        <div className="file-upload-buttons">
          <button className="file-upload-button file-upload-button-cancel" onClick={clearAll}>
            Cancel
          </button>
          <button
            className={`file-upload-button ${uploading ? "file-upload-button-disabled" : "file-upload-button-primary"}`}
            onClick={() => !uploading && fileInputRef.current.click()}
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Add object"}
          </button>
        </div>
        {errorMessage.length > 0 && (
          <div className="file-upload-error">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default Upload3DContainer;
